<div class="ft-view-body ft-cooperative-body">
    <ft-main-nav />
    <ft-header [modifierClass]="'-cooperative'">
        <div class="ft-content ft-container">
            <div class="ft-supertitle">Marketing Cooperative</div>
            <h1 class="ft-heading ft-text-plus-3">
                Unify your global marketing efforts across {{ properties().length }} organizations to bring new travelers to your destination.
            </h1>
            <div class="ft-partner-logos">
                @for (property of properties(); track property) {
                    <div class="ft-org-logo">
                        @if (property.HeaderLogoUrl) {
                            <img [src]="property.HeaderLogoUrl" />
                        }
                    </div>
                }
            </div>
        </div>
    </ft-header>

    <main class="ft-main ft-scroll-anchor">
        <ft-sections #ftSecs [registry]="sections">
            <!-- Gapless @for: v1 appended the inline-block <li> clones adjacently — with
                 preserveWhitespaces:true block whitespace paints ~4px gaps between tabs. -->
            <nav class="ft-nav ft-navbar ft-sections-nav">
                <ul>@for (section of sections; track section) {<li [attr.ft-disabled]="section.isDisabled"
                            [class.active]="section.isActive"><a (click)="ftSecs.activate(section)">{{ section.title }}</a></li>}</ul>
            </nav>

            <ft-section name="big picture"><ft-cooperative-big-picture-ng /></ft-section>
            <ft-section name="roadmap"><ft-cooperative-roadmap-ng /></ft-section>
            <ft-section name="partners"><ft-cooperative-partners-ng /></ft-section>
        </ft-sections>
    </main>
</div>
